import React from 'react';
import { NavLink } from 'react-router-dom';

/**
 * 产品功能项接口
 */
interface ProductFeature {
  id: string;
  title: string;
  description: string;
  iconName?: string;
}

/**
 * 产品功能分类接口
 */
interface ProductFeatureCategory {
  id: string;
  title: string;
  features: ProductFeature[];
}

/**
 * 产品功能菜单属性接口
 */
interface ProductFeaturesMenuProps {
  productFeatureCategories: ProductFeatureCategory[];
  isMobile?: boolean;
  mobileFeatureMenuOpen?: boolean;
  toggleMobileFeatureMenu?: (e: React.MouseEvent) => void;
  closeMobileMenu?: () => void;
}

/**
 * 产品功能菜单组件
 * 封装了桌面端链接和移动端折叠菜单的实现
 * @param {ProductFeaturesMenuProps} props - 组件属性
 * @returns {JSX.Element} 渲染的React组件
 */
const ProductFeaturesMenu: React.FC<ProductFeaturesMenuProps> = ({
  productFeatureCategories,
  isMobile = false,
  mobileFeatureMenuOpen = false,
  toggleMobileFeatureMenu = () => {},
  closeMobileMenu = () => {}
}) => {
  // 桌面端菜单实现
  if (!isMobile) {
    return (
      <NavLink to="/features">
        {({ isActive }) => (
          <div className={`font-medium transition-colors duration-200 flex items-center gap-1 relative ${isActive ? 'text-primary' : 'hover:text-primary'}`}>
            产品功能
            {/* 选中状态下显示的下划线 */}
            <span className={`absolute left-0 right-0 bottom-[-8px] h-[2px] bg-primary transform transition-transform duration-200 ${isActive ? 'scale-x-100' : 'scale-x-0'}`}></span>
          </div>
        )}
      </NavLink>
    );
  }

  // 移动端菜单实现
  return (
    <div className="relative">
      <NavLink
        to="/features"
        onClick={() => closeMobileMenu()}
      >
        {({ isActive }) => (
          <div className={`w-full text-left font-medium px-4 py-2 rounded-lg flex justify-between items-center ${isActive ? 'bg-primary/10 text-primary' : 'hover:bg-gray-100'}`}>
            产品功能
          </div>
        )}
      </NavLink>
    </div>
  );
};

export default ProductFeaturesMenu;